import {useJbHttpCrudService} from "../../core/service/jb-http-crud.service";
import {ProcessObjectEntity} from "../entity/process-object.entity";

export function useProcessObjectRepository() {
  const crud = useJbHttpCrudService<ProcessObjectEntity>('process-object');
  return {
    ...crud
  }
}